import { useEffect, useState, type FormEvent } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "娱乐八卦", to: "/category/entertainment" },
  { label: "明星黑料", to: "/category/celebrity" },
  { label: "社会热点", to: "/category/society" },
  { label: "影视资讯", to: "/category/film" },
  { label: "关于我们", to: "/about" },
];

export default function SiteHeader() {
  const location = useLocation();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState("");

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname, location.search]);

  const submitSearch = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const q = keyword.trim();
    if (!q) return;
    navigate(`/search?q=${encodeURIComponent(q)}`);
    setKeyword("");
    setMenuOpen(false);
  };

  const isActive = (to: string) =>
    to === "/" ? location.pathname === "/" : location.pathname.startsWith(to);

  return (
    <header className="sticky top-0 z-50 bg-foreground-950 text-background-50">
      <div className="hidden md:flex items-center justify-center gap-2 h-8 px-4 bg-primary-600 text-background-50 text-xs">
        <i className="ri-fire-fill" />
        <span>今日爆料持续更新 · 影视 / 综艺 / 明星动态实时追踪</span>
        <span className="opacity-70">爆料线索请前往「关于我们」提交</span>
      </div>

      <div className="px-4 md:px-6 h-16 flex items-center gap-3 md:gap-6">
        <Link to="/" className="flex items-center gap-2 shrink-0 cursor-pointer">
          <span className="w-9 h-9 rounded-md bg-primary-500 flex items-center justify-center font-heading font-extrabold text-lg">
            黑
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading font-extrabold text-lg tracking-tight">黑料</span>
            <span className="text-[10px] tracking-[0.3em] text-background-500 uppercase mt-0.5">
              Hei Liao
            </span>
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-1 flex-1 justify-center">
          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`px-3 py-2 text-sm rounded-md transition cursor-pointer whitespace-nowrap ${
                isActive(item.to)
                  ? "text-primary-400 font-medium"
                  : "text-background-300 hover:text-background-50"
              }`}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <form
          onSubmit={submitSearch}
          className="hidden md:flex items-center gap-2 bg-foreground-900 rounded-full pl-3 pr-1 py-1 w-52 xl:w-64 border border-foreground-800 focus-within:border-primary-500 transition"
        >
          <input
            value={keyword}
            onChange={(event) => setKeyword(event.target.value)}
            placeholder="搜索黑料关键词"
            className="bg-transparent text-sm text-background-50 placeholder:text-background-500 outline-none w-full"
            aria-label="站内搜索"
          />
          <button
            type="submit"
            aria-label="搜索"
            className="w-7 h-7 rounded-full bg-primary-500 flex items-center justify-center shrink-0 cursor-pointer hover:bg-primary-600 transition"
          >
            <i className="ri-search-line text-sm" />
          </button>
        </form>

        <button
          type="button"
          onClick={() => setMenuOpen((prev) => !prev)}
          aria-label="打开菜单"
          className="lg:hidden ml-auto w-9 h-9 flex items-center justify-center rounded-md border border-foreground-800 cursor-pointer"
        >
          <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
        </button>
      </div>

      {menuOpen && (
        <div className="lg:hidden border-t border-foreground-800 bg-foreground-950 px-4 pb-5 pt-3 animate-fade-in">
          <form onSubmit={submitSearch} className="flex items-center gap-2 mb-3 md:hidden">
            <input
              value={keyword}
              onChange={(event) => setKeyword(event.target.value)}
              placeholder="搜索黑料关键词"
              className="flex-1 bg-foreground-900 border border-foreground-800 rounded-md px-3 py-2 text-sm outline-none focus:border-primary-500 transition"
              aria-label="站内搜索"
            />
            <button
              type="submit"
              aria-label="搜索"
              className="w-9 h-9 rounded-md bg-primary-500 flex items-center justify-center cursor-pointer shrink-0"
            >
              <i className="ri-search-line" />
            </button>
          </form>
          <nav className="grid grid-cols-2 gap-2">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`px-3 py-2.5 text-sm rounded-md border transition cursor-pointer ${
                  isActive(item.to)
                    ? "border-primary-500 text-primary-400"
                    : "border-foreground-800 text-background-200 hover:border-background-500"
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}